import React from 'react'
import SingleProj from './SingleProj'
import CareSync from '../assets/projectImages/CareSync.png'
import MedTrack from '../assets/projectImages/MedTrack.png'
import GoPic from '../assets/projectImages/GoPic.png'
import LES from '../assets/projectImages/LES.jpg'
import ResAnalyzer from '../assets/projectImages/ResAnalyzer.png'
import VocabBuddy from '../assets/projectImages/VocabBuddy.png'


const Projects = () => {
  return (
    <div className='max-w-[1200px] mx-auto p-5' id='projects'>
        <div className='pb-8'>
            <p className='text-4xl mb-3 font-bold primary-color'>Projects</p>
            <p className='text-gray-400'>Check out some of my recent work</p>
        </div>

        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
          
            <SingleProj image={VocabBuddy} title='VocabBuddy' link={'https://github.com/moeezs/VocabBuddy'} see={'Code'} linklive={'https://youtu.be/iLDRERtZa4Y'}/>
            <SingleProj image={CareSync} title='CareSync' link={'https://github.com/moeezs/CareSync'} see={'Code'}/>
            <SingleProj image={GoPic} title='GoPic' link={'/GoPicShowcase.pdf'} see={'View'}/>
            <SingleProj image={MedTrack} title='MedTrack' link={'https://github.com/moeezs/MedTrack'} see={'Code'}/>
            <SingleProj image={ResAnalyzer} title='Resume Analyzer' link={'https://github.com/moeezs/Resume-Analyzer'} see={'Code'} linklive={'https://moeezs.github.io/Resume-Analyzer/'} />
            <SingleProj image={LES} title='Local Email System' link={'https://github.com/moeezs/Local-Email-System'} see={'Code'}/>

        </div>
    </div>
  )
}

export default Projects